<template>
  <div>
    <b-modal v-model="showDetails" size="lg" :title="title">
      <div class="row">
        <div class="col col-12">
          <ul id="propriedadesAuditTrail">
            <li v-for="(propertyNameValue, index) in writeData" :key="index">{{ propertyNameValue }}</li>
          </ul>
        </div>
      </div>

      <template v-slot:modal-footer>
        <div class="row">
          <b-btn-group class="mr-2">
            <b-btn block variant="default" @click="closeDetails">Fechar</b-btn>
          </b-btn-group>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    title: { default: 'Detalhes' },
    useJsonName: { default: true }
  },

  data () {
    return {
      showDetails: false,
      objJson: null,
      objNames: null,
      writeData: []
    }
  },
  methods: {
    closeDetails () {
      this.showDetails = false
    },
    openModal (data, useObjectName = true) {
      let th = this
      th.showDetails = true
      let propertyNames = Object.getOwnPropertyNames(data)
      th.objJson = data
      th.objNames = []
      th.writeData = []

      propertyNames.forEach(function (name) {
        th.objNames.push(name)
      })

      for (var i = 0; i < th.objNames.length; i++) {
        if (useObjectName) { th.writeData.push(th.objNames[i] + ': ' + th.objJson[th.objNames[i]]) } else {
          if (th.objNames[i] !== 'length') { th.writeData.push(th.objJson[th.objNames[i]]) }
        }
      }

      th.showDetails = true
    }
  }
}
</script>
